exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#show-barcode-scanner .scan-area{left:25%;top:15%;width:50%;height:60%;box-shadow:0 0 0 10000px rgba(0,0,0,.4);border:2px solid red}#show-barcode-scanner .scan-area:after{content:\"\";display:block;height:2px;width:100%;position:absolute;top:calc(50% - 1px);left:0;background-color:red}#show-barcode-scanner .scan-area.detected{border:3px solid #80ff80}", ""]);

// exports
